import { QBox, QText } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';
import styles from './FileDocumentLoadingIndicator.module.css';

export const FileDocumentLoadingIndicator = () => {
  const { t } = useTranslation();
  return (
    <QBox className={styles['loading-spinner-wrapper']}>
      <QText data-cy="loading-text" id={'loadingMessage'} fontSize={'sm'}>
        {t('messages.previewBeingGenerated')}
      </QText>
      <QBox>
        <LoadingSpinner />
      </QBox>
    </QBox>
  );
};
